import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';

export interface TaxCategoryDto {
  id: string;
  code: string;
  description: string | null;
  createdAt: string;
  lastModified: string | null;
  createdByUserId: string | null;
  updatedByUserId: string | null;
}

export interface TaxCategoryCreateDto {
  code: string;
  description: string | null;
}

export type TaxCategoryUpdateDto = TaxCategoryCreateDto;

@Injectable({
  providedIn: 'root'
})
export class TaxCategoriesService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  readTaxCategories(): Observable<TaxCategoryDto[]> {
    return this.#http.getData(`${this.baseUrl}/TaxCategory`, { showLoader: true, showMessage: true });
  }

  getTaxCategoryById(id: string): Observable<TaxCategoryDto> {
    return this.#http.getData(`${this.baseUrl}/TaxCategory/${id}`, { showLoader: true, showMessage: true });
  }

  createTaxCategory(payload: TaxCategoryCreateDto): Observable<TaxCategoryDto> {
    return this.#http.postData(
      `${this.baseUrl}/TaxCategory`,
      { showLoader: true, showMessage: true, message: 'Tax Category created successfully' },
      payload
    );
  }

  updateTaxCategory(id: string, payload: TaxCategoryUpdateDto): Observable<TaxCategoryDto> {
    return this.#http.putData(`${this.baseUrl}/TaxCategory/${id}`, payload, {
      showLoader: true,
      showMessage: true,
      message: 'Tax Category updated successfully'
    });
  }

  deleteTaxCategory(id: string): Observable<void> {
    return this.#http.deleteData(`${this.baseUrl}/TaxCategory/${id}`, {
      showLoader: true,
      showMessage: true,
      message: 'Tax Category deleted successfully'
    });
  }
}
